import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {UserDetailsComponent} from './user-details.component';

const routes: Routes = [
  {path: 'user/details', component: UserDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class UserDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-details/user-details-routing.module.ts